import type { TenantConfig } from '@/types/TenantConfig'

const warmWhite = '#E3E0DB'
const black = '#030D02'
const beige = '#B6AF9E'

export const bundanon: TenantConfig = {
  logo: 'assets/bundanon/static/logo.png',
  themeOptions: {
    pageBackgroundColor: warmWhite,
    headerBackground: black,
    logoHeight: '45px',
    headerHeight: '121px',
    cartHeaderBackgroundColor: 'white',
    cartHeaderTextColor: black,
    cartHeaderBorder: 'var(--light-gray) solid 1px',
    primaryColor: black,
    secondaryColor: beige,
    footerBackgroundColor: black,
    footerTextColor: warmWhite,
    memberLinksColor: warmWhite,
    memberLinksColorHover: beige,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    // completedOrdersRoute: {
    //   completedImage: {
    //     desktop: 'assets/townhallseattle/static/completed.jpg',
    //   },
    //   completedContentOffset: {
    //     desktop: '-300px',
    //     mobile: '-250px',
    //   },
    // },
  },
}
